import axios from 'axios';
import qs from 'qs';
import { unionFlag } from './index';
import Cookies from 'js-cookie';
import API_ENV from './API_ENV';
import Toast from './../components/simpleToast';
import { getQueryString } from '@utils';
import { bfdApi } from "@utils/constant";

let appAPI; // 网关
let mallAPI; // 非网关
let bfdNewApi; // 百福得
let specielApiFLag; // 特殊 api 返回整个 data

console.log('API_ENV', API_ENV, bfdApi);
if (
  API_ENV === 'production' ||
  API_ENV === 'test05' ||
  API_ENV === 'uat' ||
  API_ENV === 'dev' ||
  API_ENV === 'stage'
) {
  // 生产环境
  appAPI = '/gw/app';
  mallAPI = '/mallapi';
  bfdNewApi = '';
} else if (/test\d{2}$/g.test(API_ENV)) {
  // k8s环境
  appAPI = `http://appzuul.${API_ENV}.com`;
  mallAPI = `http://api.${API_ENV}.com`;
  bfdNewApi = '';
} else {
  appAPI = '/gw/app/';
  mallAPI = '/mallapi';
  bfdNewApi = '';
}

/**
 * 创建一个axios实例
 */
const _axios = axios.create();
const OK = 0;

/**
 * 接口数据为空的时候也只返回数据
 */
const whiteApis = ['/birthday/pc/brandDetail'];
// 请求前添加拦截器
const _axios_req = _axios.interceptors.request.use((config,a) => {
  /**
   * 拦截器统一处理公共请求参数
   * 非工会参数：cityId、platform
   * 工会参数：unionFlag、union、cityId、platform
   */
  const union = unionFlag() || sessionStorage.getItem('dffl_union');
  const cityId = Cookies.get('address') && JSON.parse(Cookies.get('address')).cityId || getQueryString('city');
  let params;

  if (window.df_sdk_common.isBfd()) {
    params = {
      unionFlag: 1,
      union,
      cityId,
      city: cityId,
      platform: 0,
    };

    config.data = { ...params, ...config.data };
  } else {
    params = {
      cityId,
      platform: 0,
    };

    config.data = { ...params, ...config.data };
  }
  return config;
});

// 响应后添加拦截器
const _axios_res = _axios.interceptors.response.use((res) => {
  // console.log(res.data instanceof Blob);
  // 处理二进制流
  if (res.data instanceof Blob) {
    return res.data;
  };
  const {code, respCode } = res.data;
  if (parseInt(code) === 101120) {
    Toast.info(res.data.msg, 3, () => {

    });
    setTimeout(() => {
      window.location.reload();
    }, 2500);
  }
  // 加购 提示
  // 加购接口、 购物车更新接口
  if(Number(code) === OK && res.data.msg && res && res.config && res.config.url && ['/newCartContract/addCartItem','/newCartContract/updateCartGoodNum'].indexOf(res.config.url) != -1){
    Toast.info(res.data.msg || msg, 3);
  }
  if (Number(code) === OK || Number(respCode) === OK || Number(code) === 7 || Number(code) === 8 || Number(code) === 101030 ) {

    console.log("res.config.url",res.config.url, whiteApis.includes(res.config.url));
    if ((!res.data.body || specielApiFLag) && !whiteApis.includes(res.config.url)) {
      return res.data;
    }
    return res.data.body;
  }
  if( Number(code) === 200){
    return res.data;
  }
  if( Number(code) === 120026 || Number(code)===121010 || Number(code)===101028 || Number(code)===90001){
    return res.data;
  }

  // df-gw网关接口返回成功
  if (code === 'BFF000000'){
    return res.data;
  }

  // 确认订单福利卡帮卡接口，错误原因显示在页面上
  if(res.config.url.indexOf('/user/card/bindvalidate') > -1 || res.config.url.indexOf('info/external/paypassword/validate') > -1 || res.config.url.indexOf('birthday/pc/brand/goodsList') > -1 ){
    return res.data;
  }

  // if (res && res.data){
  //   return res.data;
  // }
  // return res.data;
  return Promise.reject(res);
});

/**
 * 封装获取数据的请求方法
* @param  { String }  url    接口路径
 * @param  { Object }  data   请求参数
 * @param  { String }  method 默认POST, 区别POST/GET方式
 * @param  { baseURLStr } baseURLStr String类型，默认undefined, 兼容区别之前定义的baseURL。baseURL应该交给接口定义，这样更灵活
 * @param  { Bollean } baseURL 默认appAPI,区别mallAPI/appAPI接口
 * @param  { Boolean } applicationType 默认json,区别json/x-www-form-urlencoded类型
 * @param  { Boolean } deleteEmptyProp 是否需要删除假值参数, 默认开启
 * @param  { Boolean } imgType 是否返回数据类型为blob
 * @param  { Boolean } Business Business-Type
 * @param  { Boolean } specielApi 是否为特殊api
 * @param  { Boolean } bfdURL 是否为百福得bfdApi = `//${unionFlag()}-corp${envMap[API_ENV]}.dongfangfuli.com`下接口
 * @return { Promise }
 */
function sendPost({
  url,
  data,
  method = 'POST',
  baseURLStr = undefined,
  baseURL = true,
  applicationType = true,
  deleteFalsyProp = true,
  imgType = false,
  Business = true,
  specielApi = false,
  bfdURL = false,
}) {
  specielApiFLag = specielApi;
  let requestHeader = {
    'Content-Type': applicationType
      ? 'application/json'
      : 'application/x-www-form-urlencoded',
    'Business-Type': 2,
  };
  let noBusiness = {
    'Content-Type': applicationType
      ? 'application/json'
      : 'application/x-www-form-urlencoded',
  };

  const getBaseURL = () => {
    if (typeof baseURLStr === 'string') return baseURLStr;
    if (bfdURL) return bfdApi;
    if (baseURL) return appAPI;
    return mallAPI;
  };

  return _axios({
    url,
    method,
    data,
    baseURL: getBaseURL(),
    transformRequest: [
      function(req) {
        deleteFalsyProp && deleteFalsyProps(req);
        return applicationType
          ? JSON.stringify(req)
          : qs.stringify(req, {
            allowDots: true,
          });
      }
    ],
    headers:  Business?  requestHeader : noBusiness,
    timeout: 15000,
    withCredentials: true,
    responseType: imgType? 'blob' : '',
  }).catch(error => {
    console.log("error",error,error.response);
    if (typeof error === 'object') {
      // gio不验证
      if(error.config.url.indexOf('api.growingio')>-1 || error.config.url.indexOf('/usercoord/usercard/external/validate')> -1){
        return;
      }

      const { code, msg, message } = error.data || error.response.data || {};
      const { failedMsg } = data || {}; // 支付前台订单 msg
      switch (code) {
      case "AUTH001999":
      case 101002:
      case '99':
        if (!data.ignore) {
          Toast.info(msg, 2, () => {
            let loginUrl = JSON.parse(sessionStorage.getItem('loginInfo')).loginUrl || JSON.parse(sessionStorage.getItem('loginInfo')).pcLoginUri;
            let loginOutUrl = JSON.parse(sessionStorage.getItem('loginInfo')).logoutUrl;
            if (loginUrl) {
              window.df_sdk_common.location.href = loginUrl + '&returnUrl=' + encodeURIComponent(window.location.href);
            } else if (loginOutUrl) {
              window.df_sdk_common.location.href = loginOutUrl + '?returnUrl=' + encodeURIComponent(window.location.href);
            }
          });
        }
        break;
      default:
        if ((code !== 999000)) {
          Toast.info(failedMsg || msg || message, 1);
        }
      }
    }
  });
}

/**
 * 删除假值类的属性
 * @param {Object}
 */
function deleteFalsyProps(obj) {
  for (const key in obj) {
    const val = obj[key];
    // 简单数据类型
    if (typeof val === 'string' || typeof val === 'undefined') {
      // ''、 undefined
      if (val === undefined) {
        delete obj[key];
      }
    }

    // 复杂数据类型
    if (typeof val === 'object') {
      if (!val) {
        // null
        delete obj[key];
      } else {
        // []
        if (Array.isArray(val) && !val.length) {
          delete obj[key];
        }
        // {}
        if (isEmpty(val)) {
          delete obj[key];
        }
      }
    }
  }
}

/**
 * 判断一个对象是否为空
 * @param {Object} obj 对象
 */
function isEmpty(obj) {
  const arr = Object.keys(obj);
  return !arr.length;
}

export { sendPost, _axios, _axios_req, _axios_res };
